import { useState, useEffect } from "react";
import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function usePageData(pageSlug) {
  const [sections, setSections] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/pages/${pageSlug}`).then(res => {
      const map = {};
      res.data.forEach(s => { map[s.section_key] = s; });
      setSections(map);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [pageSlug]);

  return { sections, loading };
}

export function useSettings() {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    axios.get(`${API}/settings`).then(res => setSettings(res.data)).catch(() => {});
  }, []);
  return settings;
}

export function useAddresses() {
  const [addresses, setAddresses] = useState([]);
  useEffect(() => {
    axios.get(`${API}/addresses`).then(res => setAddresses(res.data)).catch(() => {});
  }, []);
  return addresses;
}
